__turbopack_context__.v({
  "container": "InlineLink-module-scss-module__mluPya__container",
});
